module.exports = __webpack_public_path__ + "img/124.0cbac622.jpg";